const NONE = 'none';
const SUCCESS = 'success';
const ERROR = 'error';
const LOADING = 'loading';

export { NONE, SUCCESS, ERROR, LOADING };
